import React from 'react';
import IconArrowDown from 'images/icons/arrow-down.svg';
import cx from 'classnames';
import Linker from 'app/shared/modules/Linker';
import './style.scss';

type LinkToggleProps = {
  linkType?: string;
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
};

type LinkToggleState = {
  isOpen: boolean;
};

class LinkToggle extends React.Component<LinkToggleProps, LinkToggleState> {
  static defaultProps = {
    linkType: 'default',
  };

  constructor(props: LinkToggleProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  handleToggle = () => {
    const { onClick } = this.props;
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });
    if (onClick) {
      onClick();
    }
  };

  render() {
    const { linkType, className } = this.props;
    const classes = {
      'LinkToggle-arrow': true,
      'LinkToggle-open': this.state.isOpen,
    };
    return (
      <div className={cx('LinkToggle', className)}>
        <Linker className="LinkToggle-linker" onClick={this.handleToggle} linkType={linkType} useButton>
          <img src={IconArrowDown} className={cx(classes)} alt="" width="16" height="16" aria-hidden="true" />
          {this.props.children}
        </Linker>
      </div>
    );
  }
}

export default LinkToggle;
